import {
  getActuatorFilter,
  getAssemblyParams,
  getAssemblyParamsInputType,
  getAssemblyParamsWithDefaultDiffPressure,
  getDiffPressureAttr,
  getFilteredMandatoryAttr,
} from './utils';

export const getRequestPayload = (
  erpSystem,
  language,
  limit,
  skip,
  query,
  selectFilterAttributes,
  currentStep,
  selectedItem,
  differentialPressAttr,
  mandatoryItemAttr,
  isNonDirectMount,
  couplingMandatoryAttr,
  bracketMandatoryAttr,
) => {
  let payload = {
    erpSystem,
    language,
    limit,
    skip,
    query,
  };

  if (currentStep === 1) {
    //removing basicform and norm filter static values from payload
    const filters = selectFilterAttributes[1].filter.attributes.filter(
      filterItem =>
        filterItem.attributeIdentifier !== 'basicForm' &&
        filterItem.values[0] !== 'All',
    );
    const payloadFilters = {
      filter: {
        basicForm: selectFilterAttributes[1].filter.basicForm,
        attributes: filters,
      },
    };
    payload = { ...payload, ...payloadFilters };
  } else if (currentStep === 2) {
    let diffPressFilterAttronSelect = {};
    let assemblyParams = {};

    const actuatorFilter = getActuatorFilter(
      selectFilterAttributes[currentStep],
      selectFilterAttributes[1],
      isNonDirectMount,
    );

    diffPressFilterAttronSelect = getDiffPressureAttr(
      selectFilterAttributes[currentStep],
    );

    const inputType = getAssemblyParamsInputType(
      selectFilterAttributes[currentStep].filter.attributes,
    );
    if (diffPressFilterAttronSelect['noData'] === 'noData') {
      assemblyParams = getAssemblyParamsWithDefaultDiffPressure(
        selectedItem,
        differentialPressAttr,
        mandatoryItemAttr,
        inputType,
        selectFilterAttributes[2].filter.basicForm,
        isNonDirectMount,
        couplingMandatoryAttr,
        bracketMandatoryAttr,
      );
    } else {
      assemblyParams = getAssemblyParams(
        selectedItem,
        diffPressFilterAttronSelect,
        mandatoryItemAttr,
        inputType,
        selectFilterAttributes[2].filter.basicForm,
        isNonDirectMount,
        couplingMandatoryAttr,
        bracketMandatoryAttr,
      );
    }

    payload = { ...payload, ...actuatorFilter, ...assemblyParams };
  } else {
    let filterMandatoryAttr;
    const actuatorBasicForm = selectFilterAttributes[2].filter.basicForm;
    filterMandatoryAttr = getFilteredMandatoryAttr(
      selectedItem,
      mandatoryItemAttr,
      currentStep,
      actuatorBasicForm,
    );

    const attributes = {
      attributes: {
        ...filterMandatoryAttr,
      },
    };
    let assemblyParams = {
      assemblyParams: attributes,
    };
    if (currentStep === 3) {
      const filterAttributes = getMonitoringFilterAttributes(
        selectFilterAttributes,
        currentStep,
      );
      if (filterAttributes.filter.monitoringType === 'dual_sensor') {
        assemblyParams = getSensorsMandAttr(
          selectedItem,
          mandatoryItemAttr,
          assemblyParams,
          actuatorBasicForm,
        );
      }
      payload = { ...payload, ...filterAttributes, ...assemblyParams };
    } else {
      payload = {
        ...payload,
        ...selectFilterAttributes[currentStep],
        ...assemblyParams,
      };
    }
  }
  return payload;
};

// Function to get the sensors mandatory attributes append the values
function getSensorsMandAttr(
  selectedItem: any,
  mandatoryItemAttr: any,
  assemblyParams: { assemblyParams: { attributes: any } },
  actuatorBasicForm: any,
) {
  const ismountingPart = selectedItem?.mountingPart ? 'Yes' : 'No';
  const selectPuckData = selectedItem.pucks || [];
  const availablePuckData = selectPuckData
    .map(item => item.attributes)
    .flat()
    .filter(attr => attr.attributeIdentifier.includes(mandatoryItemAttr))
    .map(attr => attr.value);
  if (actuatorBasicForm === 'gearbox') {
    assemblyParams = {
      assemblyParams: {
        attributes: {
          [mandatoryItemAttr]: availablePuckData.join('#'),
          MOUNTING_APPLY: ismountingPart,
          ACTUATOR_TYPE: actuatorBasicForm,
        },
      },
    };
  } else {
    assemblyParams = {
      assemblyParams: {
        attributes: {
          [mandatoryItemAttr]: availablePuckData.join('#'),
        },
      },
    };
  }

  return assemblyParams;
}
// Function to get the monitoring filter attributes
function getMonitoringFilterAttributes(selectFilterAttributes, currentStep) {
  const monitoringType = getMonitoringType(selectFilterAttributes[3]);

  const monitoringFilter = selectFilterAttributes[
    currentStep
  ].filter.attributes.filter(
    x => x.attributeIdentifier !== 'EGTF_3734__STRING',
  );

  let attributes = {
    basicForm: selectFilterAttributes[currentStep].filter.basicForm,
    monitoringType: monitoringType,
    attributes: monitoringFilter,
  };
  const filterAttributes = { filter: attributes };
  return filterAttributes;
}

// Function to get the monitoring type in string format
export function getMonitoringType(selectFilterAttributes: any) {
  return selectFilterAttributes.filter.attributes
    .find(attrItem => attrItem.attributeIdentifier === 'EGTF_3734__STRING')
    ?.values[0].toLowerCase();
}
